export const PHONE_FIELD_MASK = { placeholder: '(999) 999-9999', pattern: '(000) 000-0000', toValue: true };
export const MILEAGE_FIELD_MASK = {
  mask: Number,
  placeholder: 'Enter Mileage',
  pattern: '[0-9]*',
  // other options are optional with defaults below
  thousandsSeparator: ',', // any single char
  min: 0,
  max: 999999,
  toValue: true,
};

export const VIN_FIELD_MASK = {
  mask: '*****************',
  definitions: {
    '*': /[A-Za-z0-9]/,
  },
  placeholderChar: '_',
  toValue: true,
};
